"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _isString = _interopRequireDefault(require("lodash/fp/isString"));
var _eventHandler = require("@active/react-utils/eventHandler");
var _excluded = ["size", "type", "children", "className", "disabled", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LinkButton = function LinkButton(_ref, ref) {
  var size = _ref.size,
    type = _ref.type,
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var handleClick = (0, _react.useCallback)(function (e) {
    !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
  }, [disabled, onClick]);
  var handleKeyDown = (0, _eventHandler.useOnKeyboardConfirm)(function (e) {
    !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
  }, [disabled, onClick]);
  var manipulatedChildren = _react["default"].Children.map(children, function (child) {
    return (0, _isString["default"])(child) ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "link-btn-label"
    }, child) : child;
  });
  var ariaButtonProps = {
    role: 'button',
    tabIndex: disabled ? -1 : 0
  };
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])('link-btn', (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "link-btn-".concat(type), type), "link-btn-".concat(size), size && size !== 'md'), "disabled", disabled), className),
    "data-testid": "link-button-root",
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, ariaButtonProps, rest), manipulatedChildren);
};
var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(LinkButton);
var _default = exports["default"] = Composed;